import { render } from "./ContentFooter.vue?vue&type=template&id=160fda2e&scoped=true"
import script from "./ContentFooter.vue?vue&type=script&lang=js"
export * from "./ContentFooter.vue?vue&type=script&lang=js"

import "./ContentFooter.vue?vue&type=style&index=0&id=160fda2e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-160fda2e"

export default script